export default __webpack_public_path__ + "static/media/9.3734edf3.webp";